var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"download-button",attrs:{"href":("./pdf/" + _vm.pdf),"download":_vm.pdf}},[_vm._v(" Download ("+_vm._s(_vm.size)+") ")])}
var staticRenderFns = []

export { render, staticRenderFns }